var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Cập nhập vận đơn"}},[_c('div',[_c('lading-update-form',{staticClass:"mb-2",attrs:{"id":_vm.ladingId,"is-form-update":""},on:{"update:id":function($event){_vm.ladingId=$event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }